import { DatePipe } from '@angular/common';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { loaderInterceptor } from '@core/components/loader/loader.interceptor';
import { authInterceptor, errorInterceptor } from '@core/interceptors';
import { DialogService } from 'primeng/dynamicdialog';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import Aura from '@primeuix/themes/aura';
import { routes } from './app.routes';
import { AuthService } from '@core/services/auth.service';
import {
  GoogleLoginProvider,
  MicrosoftLoginProvider,
  SocialAuthServiceConfig,
  SOCIAL_AUTH_CONFIG,
} from '@abacritt/angularx-social-login';
import { environment } from '../environments/environment';
import { WeekDaysService } from '@shared/services/week-days.service';
import { CustomersService } from '@core/services';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    provideHttpClient(
      withInterceptors([authInterceptor, loaderInterceptor, errorInterceptor])
    ),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: 'none',
          cssLayer: {
            name: 'primeng',
            order: 'customPrimeflex, primeng, customPrimeng',
          },
        },
      },
    }),
    provideAppInitializer(() => {
      const _authService = inject(AuthService);
      const _customerService = inject(CustomersService);
      return Promise.resolve();
    }),
    {
      provide: SOCIAL_AUTH_CONFIG,
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.client_id, {
              oneTapEnabled: false,
              prompt: 'select_account',
            }),
          },
          {
            id: MicrosoftLoginProvider.PROVIDER_ID,
            provider: new MicrosoftLoginProvider(
              environment.microsoft_client_id,
              {
                redirect_uri: environment.redirect_uri,
                logout_redirect_uri: environment.logout_redirect_uri,
              }
            ),
          },
        ],
        onError: err => {
          console.error('Social Login Error:', err);
        },
      } as SocialAuthServiceConfig,
    },
    DialogService,
    MessageService,
    DatePipe,
    WeekDaysService,
  ],
};
